import { styled } from "@mui/material";
import { StyledListbox } from "../../../../components/MenuPopper/MenuPopper.styled";

export const StyledListboxExtends = styled(StyledListbox)`
  width: 100%;
`;
